import { e as _taggedTemplateLiteral, c as _slicedToArray, f as _asyncToGenerator, a as _toConsumableArray, _ as _objectSpread2, b as _objectWithoutProperties } from './_rollupPluginBabelHelpers-fb970440.js';
import { useState, useEffect } from 'react';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { gql } from '@apollo/client';

var _templateObject, _templateObject2;
var GET_PLAN_COVER_DETAILS = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getPlanCoverDetails($input: planAndCoversInput) {\n    planAndCovers(input: $input) {\n      name\n      code\n      covers {\n        name\n        index\n      }\n      packs {\n        name\n        index\n        addOnCovers {\n          name\n          index\n          selected\n        }\n      }\n    }\n  }\n"])));
var GET_DATE_TIME = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query getDateTime {\n    datetimeValue {\n      time\n      date\n    }\n  }\n"])));

var _excluded = ["covers"];

var useCoversAndPlans = function useCoversAndPlans(_ref) {
  var skip = _ref.skip,
      insuredMembers = _ref.insuredMembers,
      sumInsured = _ref.sumInsured,
      deductSumInsured = _ref.deductSumInsured,
      productCode = _ref.productCode,
      planName = _ref.planName,
      _ref$isAllPlansRequir = _ref.isAllPlansRequired,
      isAllPlansRequired = _ref$isAllPlansRequir === void 0 ? false : _ref$isAllPlansRequir,
      imdCode = _ref.imdCode;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      planData = _useState2[0],
      setPlanData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var fetchQuery = useFetchQuery();

  var fetchAllPlans = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _planAndCovers, _planAndCovers2, _planObj$packs, _planAndCovers3, dateTime, _yield$dateTime, dataTime, datetimeValue, date, getPlansAndCovers, _yield$getPlansAndCov, dataPlanCovers, planAndCovers, planObj;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(insuredMembers && sumInsured && productCode && planName && imdCode)) {
                _context.next = 27;
                break;
              }

              _context.prev = 1;
              dateTime = fetchQuery({
                query: GET_DATE_TIME
              });
              setLoading(true);
              _context.next = 6;
              return dateTime;

            case 6:
              _yield$dateTime = _context.sent;
              dataTime = _yield$dateTime.data;
              datetimeValue = dataTime.datetimeValue;
              date = datetimeValue.date;
              getPlansAndCovers = fetchQuery({
                query: GET_PLAN_COVER_DETAILS,
                fetchPolicy: 'cache-first',
                variables: {
                  input: {
                    sumInsured: sumInsured,
                    deductSumInsured: deductSumInsured,
                    startDate: date,
                    productCode: productCode,
                    members: insuredMembers.map(function (insured) {
                      insured.covers;
                          var restInsured = _objectWithoutProperties(insured, _excluded);

                      return restInsured;
                    }),
                    imdCode: imdCode
                  }
                }
              });
              _context.next = 13;
              return getPlansAndCovers;

            case 13:
              _yield$getPlansAndCov = _context.sent;
              dataPlanCovers = _yield$getPlansAndCov.data;
              planAndCovers = dataPlanCovers.planAndCovers;
              planObj = (_planAndCovers = planAndCovers) === null || _planAndCovers === void 0 ? void 0 : _planAndCovers.find(function (plan) {
                var _plan$name;

                return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
              });
              planAndCovers = planObj ? [].concat(_toConsumableArray(isAllPlansRequired ? (_planAndCovers2 = planAndCovers) === null || _planAndCovers2 === void 0 ? void 0 : _planAndCovers2.filter(function (plan) {
                var _plan$name2, _plan$name2$toString, _planName$toString;

                return (plan === null || plan === void 0 ? void 0 : (_plan$name2 = plan.name) === null || _plan$name2 === void 0 ? void 0 : (_plan$name2$toString = _plan$name2.toString()) === null || _plan$name2$toString === void 0 ? void 0 : _plan$name2$toString.toLowerCase()) !== (planName === null || planName === void 0 ? void 0 : (_planName$toString = planName.toString()) === null || _planName$toString === void 0 ? void 0 : _planName$toString.toLowerCase());
              }) : []), [_objectSpread2(_objectSpread2({}, planObj), {}, {
                packs: planObj === null || planObj === void 0 ? void 0 : (_planObj$packs = planObj.packs) === null || _planObj$packs === void 0 ? void 0 : _planObj$packs.map(function (pack) {
                  var _pack$addOnCovers;

                  return _objectSpread2(_objectSpread2({}, pack), {}, {
                    addOnCovers: pack === null || pack === void 0 ? void 0 : (_pack$addOnCovers = pack.addOnCovers) === null || _pack$addOnCovers === void 0 ? void 0 : _pack$addOnCovers.map(function (addOnCover) {
                      var _pack$index;

                      var coverSelected = true;
                      pack === null || pack === void 0 ? void 0 : (_pack$index = pack.index) === null || _pack$index === void 0 ? void 0 : _pack$index.every(function (relationship) {
                        var _insuredMembers$find, _insuredMembers$find$;

                        if (!(insuredMembers !== null && insuredMembers !== void 0 && (_insuredMembers$find = insuredMembers.find(function (insured) {
                          var _insured$relationship;

                          return (insured === null || insured === void 0 ? void 0 : (_insured$relationship = insured.relationship) === null || _insured$relationship === void 0 ? void 0 : _insured$relationship.toLowerCase()) === (relationship === null || relationship === void 0 ? void 0 : relationship.toLowerCase());
                        })) !== null && _insuredMembers$find !== void 0 && (_insuredMembers$find$ = _insuredMembers$find.covers) !== null && _insuredMembers$find$ !== void 0 && _insuredMembers$find$.find(function (cover) {
                          var _cover$index, _addOnCover$index, _cover$name, _addOnCover$name;

                          return (cover === null || cover === void 0 ? void 0 : (_cover$index = cover.index) === null || _cover$index === void 0 ? void 0 : _cover$index.toLowerCase()) === (addOnCover === null || addOnCover === void 0 ? void 0 : (_addOnCover$index = addOnCover.index) === null || _addOnCover$index === void 0 ? void 0 : _addOnCover$index.toLowerCase()) && (cover === null || cover === void 0 ? void 0 : (_cover$name = cover.name) === null || _cover$name === void 0 ? void 0 : _cover$name.toLowerCase()) === (addOnCover === null || addOnCover === void 0 ? void 0 : (_addOnCover$name = addOnCover.name) === null || _addOnCover$name === void 0 ? void 0 : _addOnCover$name.toLowerCase());
                        }))) {
                          coverSelected = false;
                          return false;
                        }

                        return true;
                      });
                      return _objectSpread2(_objectSpread2({}, addOnCover), {}, {
                        selected: coverSelected
                      });
                    })
                  });
                })
              })]) : isAllPlansRequired ? _toConsumableArray((_planAndCovers3 = planAndCovers) === null || _planAndCovers3 === void 0 ? void 0 : _planAndCovers3.filter(function (plan) {
                var _plan$name3, _plan$name3$toString, _planName$toString2;

                return (plan === null || plan === void 0 ? void 0 : (_plan$name3 = plan.name) === null || _plan$name3 === void 0 ? void 0 : (_plan$name3$toString = _plan$name3.toString()) === null || _plan$name3$toString === void 0 ? void 0 : _plan$name3$toString.toLowerCase()) !== (planName === null || planName === void 0 ? void 0 : (_planName$toString2 = planName.toString()) === null || _planName$toString2 === void 0 ? void 0 : _planName$toString2.toLowerCase());
              })) : [];
              setPlanData(planAndCovers);
              setLoading(false);
              _context.next = 27;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](1);
              setError(_context.t0);
              setPlanData([]);
              setLoading(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 22]]);
    }));

    return function fetchAllPlans() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (!skip) {
      fetchAllPlans();
    }
  }, [insuredMembers === null || insuredMembers === void 0 ? void 0 : insuredMembers.length, sumInsured, productCode, planName, imdCode, skip]);
  return {
    loading: loading,
    error: error,
    data: {
      planData: planData
    }
  };
};

export { GET_DATE_TIME as G, useCoversAndPlans as u };
